import { defineSlotRecipe } from '@chakra-ui/react';

/*
 * Design system source: .claude/skills/monetizenow-design/preview/tooltip.html
 *
 * Dark bg #1A1B2E, white 11px medium, 5px radius, 5px 9px padding.
 * (Background is intentionally distinct from the modal overlay black.)
 *
 * v3 port notes:
 * - v2's single-part `Tooltip` becomes a 3-slot component in v3
 *   (`content`/`arrow`/`arrowTip`, from `@ark-ui/react/tooltip`'s
 *   `tooltipAnatomy` — confirmed via the built-in `tooltip` recipe in
 *   `@chakra-ui/react/dist/esm/theme/recipes/tooltip.js`). Only `content` had
 *   real styling in v2; `arrow`/`arrowTip` pick up `--tooltip-bg` so the arrow
 *   matches the content background, same technique Popover already uses.
 */

const tooltipTheme = defineSlotRecipe({
  slots: ['content', 'arrow', 'arrowTip'],
  base: {
    content: {
      '--tooltip-bg': '#1A1B2E',
      px: '9px',
      py: '5px',
      bg: 'var(--tooltip-bg)',
      color: 'white',
      borderRadius: '5px',
      fontWeight: 500,
      fontSize: 'xs', // 11px
      boxShadow: 'md',
      zIndex: 'tooltip',
    },
    arrow: {
      '--arrow-background': 'var(--tooltip-bg)',
    },
    arrowTip: {
      borderColor: 'var(--tooltip-bg)',
    },
  },
  variants: {
    size: {
      xs: { content: { maxW: '150px' } },
      sm: { content: { maxW: '225px' } },
      md: { content: { maxW: '320px' } },
      lg: { content: { maxW: '400px' } },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export default tooltipTheme;
